import { gql } from '@apollo/client';
import { useQuery } from './apollo';

const QUERY = gql`
  query ($relationId: ID, $keys: [String!]!) {
    settings(relationId: $relationId, keys: $keys)
  }
`;

function useSettings({ relationId, keys }) {
  const { data, loading } = useQuery(QUERY, { variables: { relationId, keys }, skip: !keys?.length, networkPolicy: 'cache-first' });

  return { settings: data?.settings, loading };
}

export default useSettings;
